import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Header from "../../components/Header";
import BgImage from "../../components/BgImage";
import { countIssues } from "../../actions/issue";
import { Doughnut } from "react-chartjs-2";

const StatisticsByReportType = ({ countIssues }) => {
  const [reportTypeCounts, setReportTypeCounts] = useState([0, 0, 0]);
  const state = {
    labels: ["Захтев", "Прекршај", "Жалба"],
    datasets: [
      {
        label: "Rainfall",
        backgroundColor: ["#00408A", "#db3e3e", "#20ac20"],
        hoverBackgroundColor: ["#002857", "#c22424", "#20ac20"],
        data: reportTypeCounts,
      },
    ],
  };

  useEffect(() => {
    statsByReportType();
  }, []);

  const statsByReportType = async () => {
    let request = await countIssues({ reportType: "request" });
    let violation = await countIssues({ reportType: "violation" });
    let complaint = await countIssues({ reportType: "complaint" });
    setReportTypeCounts([request, violation, complaint]);
  };

  return (
    <>
      <Header></Header>
      <BgImage></BgImage>
      <div className="container mx-auto">
        <div className="text-2xl text-center mt-10 uppercase">
          Статистика о типу пријаве
        </div>
        <Doughnut
          data={state}
          options={{
            legend: {
              display: true,
              position: "top",
            },
          }}
        />
      </div>
    </>
  );
};

const mapDispatchToProps = {
  countIssues,
};

export default connect(null, mapDispatchToProps)(StatisticsByReportType);
